import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'button-novo-form-ait',
  templateUrl: './button-novo.component.html',
  styleUrls: ['./button-novo.component.scss']
})
export class ButtonNovoAitTransporteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
